<template>
	<div
		v-editable="blok"
		class="grid"
		:class="
			`${blok.items_in_row} ${blok.space_between || 'gap-4'}` ||
			'md:grid-cols-3 my-12 gap-12'
		"
	>
		<StoryblokComponent
			v-for="feature in blok.content"
			:key="feature._uid"
			:blok="feature"
			:align-button="feature.component === 'hero-with-text'"
		/>
	</div>
</template>

<script setup lang="ts">
import type { BlokColumns } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokColumns;
}

const { blok } = defineProps<Props>();
</script>
